module.exports = __webpack_public_path__ + "static/img/user-photo.8d9a879.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/user-photo.png
// module id = KhMY
// module chunks = 1